import Api from '@/plugins/api';

export default {
  datatable(context, options) {
    const store = context;
    store.state.datatable.loading = true;
    const promise = Api(store).post('/api/config/datatable', options);
    promise.then((response) => {
      store.state.datatable.items = response.data.data;
      store.state.datatable.params.totalRecords = response.data.totalRecords;
    });
    promise.finally(() => {
      store.state.datatable.loading = false;
    });

    return promise;
  },
  createConfig(context) {
    const store = context;
    store.state.createConfig.loading = true;
    const promise = Api(store).post('/api/config', store.state.createConfig.form);
    promise.finally(() => {
      store.state.createConfig.loading = false;
    });

    return promise;
  },
  updateConfig(context) {
    const store = context;
    store.state.editConfig.updateLoading = true;
    const promise = Api(store).put(`/api/config/update/${store.state.editConfig.id}`, store.state.editConfig.form);
    promise.finally(() => {
      store.state.editConfig.updateLoading = false;
    });

    return promise;
  },
  removeConfigById(context, id) {
    const store = context;
    store.state.removeConfigById.loading = true;
    const promise = Api(store).delete(`/api/config/remove/${id}`);
    promise.finally(() => {
      store.state.removeConfigById.loading = false;
    });

    return promise;
  },
  readConfigForEdit(context, id) {
    const store = context;
    store.state.editConfig.loading = true;
    const promise = Api(store).get(`/api/config/read/${id}`);
    promise.then((response) => {
      store.state.editConfig.id = response.data.id;
      store.state.editConfig.templateCode = response.data.templateCode;
      store.state.editConfig.form.code = response.data.code;
      store.state.editConfig.form.tags = [];
      store.state.editConfig.form.sets = response.data.data;
      for (let i = 0; i < response.data.tags.length; i += 1) {
        store.state.editConfig.form.tags.push(response.data.tags[i].name);
      }
    });
    promise.finally(() => {
      store.state.editConfig.loading = false;
    });

    return promise;
  },
  templates(context) {
    const store = context;
    store.state.templates.loading = true;
    const promise = Api(store).get('/api/config/templates');
    promise.then((response) => {
      store.state.templates.items = response.data;
    });
    promise.finally(() => {
      store.state.templates.loading = false;
    });

    return promise;
  },
  tags(context) {
    const store = context;
    store.state.tags.loading = true;
    const promise = Api(store).get('/api/config/tags');
    promise.then((response) => {
      store.state.tags.items = response.data;
    });
    promise.finally(() => {
      store.state.tags.loading = false;
    });

    return promise;
  },
};
